import Dropdown from "@musicfy/components/Dropdown";

export enum SortTypes {
  mostPopular = "Most Popular",
  trending = "Trending",
  newest = "Newest",
}

interface ISortFilterProps {
  sortType: SortTypes;
  setSelectedSortType: React.Dispatch<React.SetStateAction<SortTypes>>;
}

const SortFilter = ({
  sortType,
  setSelectedSortType,
}: ISortFilterProps): JSX.Element => {
  return (
    <Dropdown
      value={sortType}
      setValue={setSelectedSortType}
      options={[
        { value: SortTypes.mostPopular, label: SortTypes.mostPopular },
        { value: SortTypes.trending, label: SortTypes.trending },
        { value: SortTypes.newest, label: SortTypes.newest },
      ]}
      placeholder="Most Popular"
    />
  );
};

export default SortFilter;
